<template>
    <tbody>
        <tr>
            <td style="width: 110px;">
                <div style="width: 100px; height:50px;" class="img-thumbnail" v-if="item.image">
                    <img
                            :alt="item.manufacturer+` `+item.code"
                            :title="item.manufacturer+` `+item.code"
                            :src="item.image"
                            style="max-width: 100%; max-height: 100%;"
                            onerror="this.remove();"
                    >
                </div>
            </td>
            <td>
                <h5>
                    <b>{{item.manufacturer}} <a :href="item.link" target="_blank" title="Müüja lehele">{{item.code}}</a></b> &nbsp;
                    <a href="#"><b-icon-search scale="0.75" @click.prevent.stop="searchEvent(item.code)"></b-icon-search></a>
                </h5>
                {{item.name}}
            </td>
            <td style="width: 200px">
                <span v-for="source in item.sources" v-bind:key="source">
                    <small :class="source == item.source ? 'font-weight-bold' : ''">{{source}}&nbsp;</small>
                </span>
            </td>
            <td class="text-right">
                <h4><b>{{item.price | twoDecimals}} €</b></h4>
                <span v-if="item.identicalCount > 1">
                    <a href="#" title="Vaata veel" @click.prevent.stop="expanded = !expanded" v-show="!expanded">
                        <small>Vaata veel {{item.identicalCount-1}}&nbsp;</small>
                        <b-icon-box-arrow-in-down></b-icon-box-arrow-in-down>
                    </a>
                    <a href="#" title="Sulge" @click.prevent.stop="expanded = !expanded" v-show="expanded">
                        <small>Sulge&nbsp;</small>
                        <b-icon-box-arrow-in-up></b-icon-box-arrow-in-up>
                    </a>
                </span>
            </td>
            <td style="width: 50px;" class="text-center">
                <a href="#" title="Lisa ostukorvi">
                    <b-icon-cart-plus scale="2" @click.prevent.stop="toCartEvent(item)"></b-icon-cart-plus>
                </a>
            </td>
        </tr>
        <tr v-for="(part, index) in item.identical" v-bind:key="index" v-show="expanded">
            <td>&nbsp;</td>
            <td>
                <b>{{part.manufacturer}} <a :href="part.link" target="_blank" title="Müüja lehele">{{part.code}}</a></b>
            </td>
            <td><small>{{part.source}}</small></td>
            <td class="text-right">{{part.price | twoDecimals}} €</td>
            <td>&nbsp;</td>
        </tr>
    </tbody>
</template>

<script>

    export default {
        name: "ListRow",
        components: {
        },
        data: function(){
            return {
                expanded: false
            };
        },
        props: ['item'],
        methods: {
            searchEvent: function(searchTerm){
                this.$emit("search", searchTerm);
            },
            toCartEvent: function(item){
                this.$emit('toCart', item);
            },
        }
    }
</script>

<style scoped>

</style>